// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"dhNft2yb"};